import { useEffect, useState } from 'react';
import { Alert, Button, Container, Modal } from 'react-bootstrap';
import { useAuth } from '../auth';
import { recordSubscriptionVisit } from '../plansApi';
import PlanChooser from './PlanChooser';

// Subscription reminders never prevent an owner from managing their business.
export default function SubscriptionGate({ children }) {
  const { user, isAuthenticated } = useAuth();
  const isOwner = !!user && (user.role === 'owner' || (user.roles || []).includes('owner'));
  const [sub, setSub] = useState(null);
  const [showPlans, setShowPlans] = useState(false);
  const reload = () => recordSubscriptionVisit().then(setSub).catch(() => {});

  useEffect(() => {
    setSub(null);
    setShowPlans(false);
    if (!isAuthenticated || !isOwner) return undefined;
    let alive = true;
    recordSubscriptionVisit().then((s) => { if (alive) setSub(s); }).catch(() => {});
    return () => { alive = false; };
  }, [isAuthenticated, isOwner, user?.id, user?._id]);

  const pending = sub?.pendingActivation || ['PENDING', 'FINANCE_REVIEW'].includes(sub?.approvalRequest?.status);
  const restricted = ['FULFILMENT_ONLY', 'HIDDEN'].includes(sub?.marketplaceAccess?.mode);
  const decisionUntil = sub?.marketplaceAccess?.mode === 'AVAILABLE' && !sub.hasAccess ? sub.marketplaceAccess.decisionUntil : null;
  const warning = isOwner && sub?.moduleEnabled && !sub.hasAccess && (restricted || sub.grace?.warning);
  return (
    <>
      {warning && <Container className="pt-3">
        <Alert variant="warning">
          <strong>{pending ? 'Your subscription is awaiting verification.' : 'Your subscription needs attention.'}</strong>
          {' '}{pending
            ? 'You can continue managing your rentals while your request is reviewed.'
            : 'You can continue managing your rentals. Review your subscription to keep your business ready for customers.'}
          {' '}{restricted
            ? `Your listings are temporarily hidden from new customers and new bookings are paused. You can complete your ${sub.marketplaceAccess.pendingOrders || 0} pending orders, manage refunds and view invoices. Verified subscription access or free decision days granted by the website admin will restore listing availability.`
            : 'Your listings remain available to customers.'}
          {' '}<Button variant="link" className="p-0" onClick={() => setShowPlans(true)}>Review subscription</Button>
          {pending && <>{' '}<Button variant="link" className="p-0" onClick={reload}>Check again</Button></>}
        </Alert>
      </Container>}
      {isOwner && decisionUntil && <Container className="pt-3"><Alert variant="info">
        The website admin has granted free decision days until {new Date(decisionUntil).toLocaleDateString('en-IN')}.
        {' '}Your listings can accept bookings during this period. Review your subscription before it ends.
      </Alert></Container>}
      {children}
      <Modal show={showPlans && isOwner} onHide={() => setShowPlans(false)} size="xl" centered>
        <Modal.Header closeButton><Modal.Title>Review subscription</Modal.Title></Modal.Header>
        <Modal.Body><PlanChooser onChanged={reload} /></Modal.Body>
      </Modal>
    </>
  );
}
